import React, { useCallback, useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import { Alerts, Input, RadioGroup, Radio, DateRangePicker, Button, MultiSelect, Slider, Toast, Spinner, Chip, Tooltip } from '@kaleyra/emmy';
import FilterIcon from '../../../../../../../assets/filter.svg';
import { isArray, isEmpty } from 'lodash';
import cn from 'classnames'
import moment from 'moment';


type RequestReportPropType = {
	getOptions: any;
}

type OptionType = {
	label: string;
	value: string;
};

export type MapStateType = {
	data: any;
};

export type DispatchPropsType = {
	onClose: () => void;
	onSave: (applyTemplateData: any, callback: (resp: any, flag: boolean) => void) => void;
	onLoad: () => void;
	onLoadData: () => void;
};


type VSMS =
	| ""
	| 'yes'
	| 'no';

enum MsgContent {
	"empty" = 0,
	"yes" = 1,
	"no" = 2,

}

type ReportType =
	| "tabular"
	| "summary"
	| ""
interface RequestReport {
	"reportName": string,
	"reportType": ReportType,
	"startDate": string,
	"endDate": string,
	"sender": string[],
	"status": string[],
	"campNames": string[],
	"statusTrace": string[],
	"countries": string[],
	"msgType": string[],
	"extra": MsgContent,
	"vsms": VSMS
}
type requestReportFildName =
	| "reportName"
	| "reportType"
	| "startDate"
	| "endDate"
	| "sender"
	| "status"
	| "campNames"
	| "statusTrace"
	| "countries"
	| "msgType"
	| "extra"
	| "vsms"

const initialState: RequestReport = {
	"reportName": '',
	"reportType": '',
	"startDate": '',
	"endDate": '',
	"sender": [],
	"status": [],
	"campNames": [],
	"statusTrace": [],
	"countries": [],
	"msgType": [],
	"extra": 0,
	"vsms": ''
}

const stateReducer = (state: RequestReport, newState: Partial<RequestReport>) => ({ ...state, ...newState })

const getObjectKey = <U extends keyof T, T extends object>(key: U) => (obj: T) => obj[key];

const RequestReportTemplate: React.FC<RequestReportPropType & DispatchPropsType & MapStateType> = ({
	onClose, onSave, onLoad, data, onLoadData
}) => {
	const { t } = useTranslation();
	const [filterVisible, setFilterVisible] = useState(false);
	const [requestInprogress, SetRequestInprogress] = useState(false);
	const [requestReportForm, setRequestReportForm] = useReducer(stateReducer, initialState);
	const [dateRange, setDateRange] = useState<any>([]);
	const { smsReportData } = data;

	const handleFilterVisibility = () => {
		setFilterVisible(!filterVisible);
	};

	const handleRequestInprogress = () => {
		SetRequestInprogress(!requestInprogress);
	}

	const STATUS_LABEL: Record<string, string> = {
		'Delivered': t('overviewWidgetWhatsAppDelivered'),
		'Undelivered': t('BLD01518'),
		'NOT-SENT': t('BLD01562'),
		'FAILED': t('mainFailed')
	}

	const STATUS_TRACES: Record<string, string> = {
		'DELIVRD': t('overviewWidgetWhatsAppDelivered'),
		'NOTALLOWED': t('BLD01531'),
		'REJECTD': t('BLD00273'),
		'UNDELIV': t('BLD01518'),
		'SNDRID-NOT-ALLOTED': t('BLD01532'),
		'INV-TEMPLATE-MATCH': t('BLD01533'),
		'NO-CREDITS': t('BLD01534'),
	}

	const MSG_TYPE_LABEL: Record<string, string> = {
		'MKT': t('BLD01520'),
		'TXN': t('BLD01529'),
		'OTP': t('BLD01519'),
		'TXND': t('BLD01530'),
		'M2M': t('BLD01523')
	}

	const RequestKeyName: Record<string, string> = {
		"reportName": t('BLD01606'),
		"reportType": t('BLD01605'),
		"startDate": t('startDate'),
		"endDate": t('endDate'),
		"sender": t('BLD01604'),
		"status": t('mainStatus'),
		"campNames": t('BLD01622'),
		"statusTrace": t("BLD01603"),
		"countries": t('BLD00377'),
		"msgType": t("messageType"),
		"extra": t("messageContent"),
		"vsms": t('VSMS')
	}

	const getOptions = (key: string): OptionType[] => {
		let options: OptionType[] = [];
		let keyOptions: Record<string, any>;
		switch (key) {
			case 'status':
				keyOptions = { ...STATUS_LABEL };
				break;
			case 'sender':
				keyOptions = smsReportData?.data?.senders ? { ...smsReportData.data.senders } : {};
				break;
			case 'countries':
				keyOptions = smsReportData?.data?.countries ? { ...smsReportData.data.countries } : {};
				break;
			case 'camp_names':
				keyOptions = smsReportData?.data?.camp_names ? { ...smsReportData.data.camp_names } : {};
				break;
			case 'status_trace':
				keyOptions = { ...STATUS_TRACES };
				break;
			case 'msgType':
				keyOptions = { ...MSG_TYPE_LABEL };
				break;
			default:
				keyOptions = {};
				break;
		}
		Object.keys(keyOptions).forEach((key: string) => {
			options.push({
				label: keyOptions[key],
				value: key
			})
		})
		return options;
	}

	const getLabel = (state: string, key: string | number) => {
		let label: string;
		switch (state) {
			case 'status':
				label = STATUS_LABEL[key];
				break;
			case 'sender':
				label = smsReportData?.data?.senders ? smsReportData.data.senders[key] : "-";
				break;
			case 'countries':
				label = smsReportData?.data?.countries ? smsReportData.data.countries[key] : "-";
				break;
			case 'campNames':
				label = smsReportData?.data?.camp_names ? smsReportData.data.camp_names[key] : "-";
				break;
			case 'statusTrace':
				label = STATUS_TRACES[key];
				break;
			case 'msgType':
				label = MSG_TYPE_LABEL[key];
				break;
			case 'extra':
				label = key === '1' || key === 1 ? 'Needed' : 'Not Needed';
				break;
			case 'vsms':
				label = key === 'yes' ? 'Yes' : 'No';
				break;
			default:
				label = "-";
				break;
		}
		return label;
	}

	const resetFilter = () => {
		setRequestReportForm({
			"sender": [],
			"status": [],
			"campNames": [],
			"statusTrace": [],
			"countries": [],
			"msgType": [],
			"extra": 0,
			"vsms": ''
		})
	}

	const onChange = (event: any) => {
		let field = event.target.name;
		let value = event.target.value;
		setRequestReportForm({ [field]: value });
	};

	const onMultiSelectChange = (field: string, value: any) => {
		setRequestReportForm({ [field]: value });
	};

	const onDateChange = (value: any) => {
		if (!isArray(value)) {
			setDateRange(value);
			setRequestReportForm({
				"startDate": '',
				"endDate": '',
			});
		} else {
			let [startDate, endDate] = value;
			if (startDate && endDate) {
				setDateRange(value);
				startDate = startDate.format('DD/MMM/YYYY');
				endDate = endDate.format('DD/MMM/YYYY');
				setRequestReportForm({
					"startDate": startDate,
					"endDate": endDate,
				});
			}
		}

	};

	const onCancelFilter = () => {
		resetFilter();
		handleFilterVisibility()
	}

	const callback = (response: any, flag: boolean) => {
		handleRequestInprogress();
		if (flag && response.data && isEmpty(response.error)) {
			Toast(response.message, 'success');
			onClose();
			onLoad();
			if (!isEmpty(data.smsReportData) && data.smsReportData.data.length === 0) {
				onLoadData();
			}
		} else if (!isEmpty(response.error)) {
			Object.keys(response.error).forEach((key: any) => {
				Toast(response.error[key], 'error');
			});
		} else {
			Toast(response.message, 'error');
		}
	}

	const onRequestReportSave = () => {
		const { reportName, reportType, startDate, endDate, sender, status, campNames, statusTrace, countries, msgType, extra, vsms } = requestReportForm;

		if (reportName === '') {
			Toast(t("BLD01535"), "error");
			return;
		}
		if (reportType === '') {
			Toast(t("BLD01536"), "error");
			return;
		}
		if (startDate === '') {
			Toast(t("BLD01537"), "error");
			return;
		}
		if (endDate === '') {
			Toast(t("BLD01538"), "error");
			return;
		}

		let saveDataOb: any = {
			"report_name": reportName,
			"report_type": reportType,
			"Start_Date": startDate,
			"End_Date": endDate,
			"sender": sender,
			"status": status,
			"camp_names": campNames,
			"status_trace": statusTrace,
			"country_id": countries,
			"msg_type": msgType,
			"extra": extra,
			"vsms": vsms,
		}

		var formData = new FormData();
		for (var key in saveDataOb) {
			if (Array.isArray(saveDataOb[key]) ? saveDataOb[key].length : saveDataOb[key])
				formData.append(key, saveDataOb[key]);
		}
		handleRequestInprogress();
		onSave(formData, callback);
	}

	const renderFilter = (): React.ReactNode => {
		const { sender, status, campNames, statusTrace, countries, msgType, extra, vsms } = requestReportForm;
		return (
			<div className={Styles.formWrapper}>
				<div className={Styles.fieldContainer}>
					<MultiSelect
						placeholder={t('BLD01552')}
						value={sender}
						selectClassName={Styles.selectBox}
						className={Styles.selectBox}
						options={getOptions('sender')}
						onChange={(value) => onMultiSelectChange('sender', value)}
					></MultiSelect>
				</div>
				<div className={Styles.fieldContainer}>
					<MultiSelect
						placeholder={t('statusPlaceholder')}
						value={status}
						selectClassName={Styles.selectBox}
						className={Styles.selectBox}
						options={getOptions('status')}
						onChange={(value) => onMultiSelectChange('status', value)}
					></MultiSelect>
				</div>
				<div className={Styles.fieldContainer}>
					<MultiSelect
						placeholder={t('camCampaignName')}
						value={campNames}
						selectClassName={Styles.selectBox}
						className={Styles.selectBox}
						options={getOptions('camp_names')}
						onChange={(value) => onMultiSelectChange('campNames', value)}
					></MultiSelect>
				</div>
				<div className={Styles.fieldContainer}>
					<MultiSelect
						placeholder={t('BLD01549')}
						value={statusTrace}
						selectClassName={Styles.selectBox}
						className={Styles.selectBox}
						options={getOptions('status_trace')}
						onChange={(value) => onMultiSelectChange('statusTrace', value)}
					></MultiSelect>
				</div>
				<div className={Styles.fieldContainer}>
					<MultiSelect
						placeholder={t('selectCountry')}
						value={countries}
						selectClassName={Styles.selectBox}
						className={Styles.selectBox}
						options={getOptions('countries')}
						onChange={(value) => onMultiSelectChange('countries', value)}
						filterOption={((input: string, option: any) => {
							return option.label.toLowerCase().includes(input.toLowerCase())
						})}
					></MultiSelect>
				</div>
				<div className={Styles.fieldContainer}>
					<MultiSelect
						placeholder={t('BLD01551')}
						value={msgType}
						selectClassName={Styles.selectBox}
						className={Styles.selectBox}
						options={getOptions('msgType')}
						onChange={(value) => onMultiSelectChange('msgType', value)}
						filterOption={((input: string, option: any) => {
							return option.label.toLowerCase().includes(input.toLowerCase())
						})}
					></MultiSelect>
				</div>
				<div className={Styles.reportTypeContainer}>
					<p className={Styles.secondaryTextStyle}>
						{t('BLD01553')}
					</p>
					<RadioGroup
						className={Styles.filterRadioGroupContainer}
						value={extra}
						onChange={onChange}
						name={'extra'}
					>
						<Radio name={'reportType'} value={1}>
							<span className={Styles.radioOptionStyle}>
								{t('needed')}
							</span>
						</Radio>
						<Radio name={'reportType'} value={2}>
							<span className={Styles.radioOptionStyle}>
								{t('notNeeded')}
							</span>
						</Radio>
					</RadioGroup>
				</div>
				<div className={Styles.reportTypeContainer}>
					<p className={Styles.secondaryTextStyle}>{t('VSMS')}</p>
					<RadioGroup
						className={Styles.filterRadioGroupContainer}
						value={vsms}
						onChange={onChange}
						name={'vsms'}
					>
						<Radio name={'reportType'} value={'yes'}>
							<span className={Styles.radioOptionStyle}>
								{t('yes')}
							</span>
						</Radio>
						<Radio name={'reportType'} value={'no'}>
							<span className={Styles.radioOptionStyle}>
								{t('no')}
							</span>
						</Radio>
					</RadioGroup>
				</div>
			</div>
		);
	};

	const getFilterCount = useCallback((): number => {
		let count = 0
		Object.keys(requestReportForm).filter((key: any) => {
			return !(["reportName", "reportType", "startDate", "endDate"].includes(key));
		}).forEach((key: any) => {
			let value = getObjectKey<keyof RequestReport, RequestReport>(key)(requestReportForm);
			if (Array.isArray(value)) {
				count += value.length
			}
			else if (value) {
				count++
			}
		});

		return count;

	}, [requestReportForm])

	const onRemoveFilter = (key: requestReportFildName) => {
		delete requestReportForm[key];
		setRequestReportForm({ ...requestReportForm })
	}

	const getFilterTags = useCallback((): React.ReactNode[] => {
		let tags: React.ReactNode[] = []
		Object.keys(requestReportForm).filter((key: any) => {
			return !(["reportName", "reportType", "startDate", "endDate"].includes(key));
		}).forEach((key: any) => {
			let value: string | string[] | MsgContent = getObjectKey<keyof RequestReport, RequestReport>(key)(requestReportForm);
			if (Array.isArray(value) && value.length) {
				tags.push(
					<Tooltip
						placement="bottom"
						title={value.map(item => getLabel(key, item)).join(", ")}
						trigger={['hover', 'click']}
					>
						<span>
							<Chip
								closable
								label={`${RequestKeyName[key]}-${value.length}`}
								chipStyle={{
									display: 'inline-flex',
									marginTop: '0.5rem',
									marginRight: '0.5rem',
								}}
								onClose={() => onRemoveFilter(key)}
							/>
						</span>
					</Tooltip>)
			}
			else if (!Array.isArray(value) && value) {
				return tags.push(<Chip
					closable
					label={`${RequestKeyName[key]}-${getLabel(key, value)}`}
					chipStyle={{
						display: "inline-flex",
						marginTop: '0.5rem',
						marginRight: '0.5rem',
					}}
					onClose={() => onRemoveFilter(key)}
				/>)
			}
		});

		return tags;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [requestReportForm])

	const renderRequestFormBody = (): React.ReactNode => {
		const { reportName, reportType } = requestReportForm;
		const filterCount = getFilterCount();
		return (
			<div className={Styles.formWrapper}>
				<div className={cn(Styles.alert, Styles.alertText)}>
					<Alerts
						customImage={<></>}
						content={t('KLR0034')}
						type="draft"
					>
					</Alerts>
				</div>

				<p className={Styles.secondaryTextStyle}>{t("KLR0035")}</p>
				<DateRangePicker
					inputStyle={Styles.datePickerWrapper}
					placeholder={[
						t('BLD00530'),
						t('BLD00151')
					]}
					disabledDate={(current: any) => {
						return current && current > moment().endOf('day');
					}}
					formatForDatePicker={'DD MMM YYYY'}
					value={dateRange}
					onClear={onDateChange}
					onOk={onDateChange}
				/>
				<Input
					placeholder={t('mainTitle')}
					value={reportName}
					name="reportName"
					onChange={onChange}
					style={{ height: '3rem' }}
				/>
				<div className={Styles.reportTypeContainer}>
					<p className={Styles.secondaryTextStyle}>{t("typeOfReport")}</p>
					<RadioGroup
						className={Styles.radioGroupContainer}
						value={reportType}
						onChange={onChange}
						name={'reportType'}
					>
						<Radio name={'reportType'} style={{ marginRight: "6rem" }} value={'summary'}>
							<span className={Styles.radioOptionStyle}>
								{t('summary')}
							</span>
						</Radio>
						<Radio name={'reportType'} value={'tabular'}>
							<span className={Styles.radioOptionStyle}>
								{t('detailed')}
							</span>
						</Radio>

					</RadioGroup>
				</div>
				<div className='d-flex justify-content-between'>
					<div>
						<p className={cn(Styles.primaryTextStyle)} style={{ margin: "0" }}>{t('Filters')}</p>
						<p className={Styles.secondaryTextStyle} style={{ margin: "0" }}>
							{t('setFilter')}
						</p>
					</div>
					{filterCount ? <div>
						<Button
							type={'secondary'}
							iconPosition={'right'}
							className={"d-flex-right"}
							onClick={handleFilterVisibility}
							small
						>
							{t('mainEdit')}
						</Button>
					</div> : null}
				</div>
				{
					filterCount ?
						<div className={Styles.filterTagContainer}>
							{getFilterTags()}
						</div>
						: <div className={Styles.filterButtonContainer}>
							<Button
								type={'secondary'}
								icon={<img alt="filter" src={FilterIcon} />}
								iconPosition={'left'}
								onClick={handleFilterVisibility}
								small
							>
								{t('BLD015625')}
							</Button>
						</div>
				}
			</div>
		);
	};

	const getFooter = (): React.ReactNode => {
		return (
			filterVisible ? (<div className={Styles.footerContainer}>
				<Button type="tertiary" onClick={onCancelFilter}>
					{t('mainCancel')}
				</Button>
				<Button type="primary" onClick={handleFilterVisibility}>
					{t('apply')}
				</Button>
			</div>) :
				(<div className={Styles.footerContainer}>
					<Button type="tertiary" onClick={onClose}>
						{t('mainCancel')}
					</Button>
					<Button type="primary" disabled={requestInprogress} onClick={onRequestReportSave}>
						{requestInprogress ? <Spinner /> : t('mainSave')}
					</Button>
				</div>)
		);
	};

	return (
		<>
			<Slider
				onClose={onClose}
				title={filterVisible ? t('KLR0039') : t('requestReport')}
				containerId={'root-modal'}
				footer={getFooter()}
				visibility={true}
			>
				{!filterVisible && renderRequestFormBody()}
				{filterVisible && renderFilter()}
			</Slider>

		</>
	);
};

export default React.memo(RequestReportTemplate);
